import {
  getSingleChoiceValue,
  getTrueFalseSingleChoiceValue,
  PLAYER_PORTALS_MODELS,
} from '@r-and-a-shared-ui/common-kontent-client';

export const table_column = (entry: PLAYER_PORTALS_MODELS.TableColumn) => {
  if (!entry || !entry?.elements) {
    return undefined;
  }
  const { elements } = entry || {};

  return {
    id: elements?.id?.value,
    label: elements?.label?.value,
    alignment: getSingleChoiceValue(elements?.alignment),
    disableSorting: getTrueFalseSingleChoiceValue(elements?.disable_sorting),
  };
};

export default table_column;
